import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useEditClinicsLoyaltyList = (options = {}) => {
  const res = useMutation(
    (dto) => http.post(HTTP_ENDPOINTS.editClinicLoyaltyList(), dto),
    {
      ...options,
    },
  );
  return res;
};
